import { useEffect } from "react";
import ScheduleVisitDialog from "@/components/ScheduleVisitDialog";

const setMeta = (name: string, content: string, attr: "name" | "property" = "name") => {
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};
const setCanonical = (href: string) => {
  let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const WA = "5521973548387";
const waMain = `https://wa.me/${WA}?text=${encodeURIComponent(
  "Olá Paulo, vi a landing page do Apart Hotel na Rua Dias Ferreira no Leblon e quero saber mais."
)}`;
const waMorar = `https://wa.me/${WA}?text=${encodeURIComponent(
  "Olá Paulo, tenho interesse em morar no Apart Hotel da Rua Dias Ferreira no Leblon. Pode me enviar mais informações?"
)}`;
const waInvestir = `https://wa.me/${WA}?text=${encodeURIComponent(
  "Olá Paulo, tenho interesse em investir no Apart Hotel da Rua Dias Ferreira no Leblon. Pode me enviar a simulação de retorno?"
)}`;

const Reveal = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => (
  <div className={`reveal ${className}`}>{children}</div>
);

const ApartHotelLeblon = () => {
  useEffect(() => {
    document.title = "Apartamento 2 Quartos no Leblon | Próximo à Praia";
    setMeta("description", "Excelente apartamento no Leblon com 56m², 2 quartos, 1 vaga e vista livre. A poucos passos da praia, metrô Jardim de Alah e Shopping Leblon.");
    setMeta("og:title", "Apartamento 2 Quartos no Leblon | Próximo à Praia", "property");
    setMeta("og:description", "Excelente apartamento no Leblon com 56m², 2 quartos, 1 vaga e vista livre. A poucos passos da praia, metrô Jardim de Alah e Shopping Leblon.", "property");
    setMeta("og:type", "website", "property");
    setMeta("keywords", "Apartamento 2 quartos Leblon, Apart Hotel Dias Ferreira, Apartamento Leblon próximo à praia, Investimento Leblon, Topclass Imóveis Leblon");
    setCanonical("https://topclassimoveis.com/leblon/apart-hotel-dias-ferreira");

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <>


      <style>{`
        .reveal { opacity: 0; transform: translateY(24px); transition: opacity .75s ease, transform .75s ease; }
        .reveal.visible { opacity: 1; transform: translateY(0); }
        .lp-hero-bg {
          background:
            linear-gradient(180deg, transparent 55%, hsl(var(--navy)) 100%),
            repeating-linear-gradient(45deg, hsla(43,96%,56%,0.025) 0 1px, transparent 1px 12px),
            linear-gradient(135deg, hsl(var(--navy)) 0%, hsl(var(--navy-light)) 100%);
        }
        .lp-scroll-line {
          width: 1px; height: 40px;
          background: hsl(var(--gold));
          opacity: .6;
          transform-origin: top;
          animation: lpScroll 2s ease-in-out infinite;
        }
        @keyframes lpScroll {
          0%,100% { transform: scaleY(1); opacity: .6; }
          50% { transform: scaleY(.4); opacity: .15; }
        }
        .lp-section { padding: 96px 32px; }
        @media (max-width: 768px) { .lp-section { padding: 64px 24px; } }
        .lp-gold-italic { color: hsl(var(--gold)); font-style: italic; }
        .lp-eyebrow {
          font-size: 11px; letter-spacing: .22em; text-transform: uppercase;
          color: hsl(var(--gold)); font-family: 'Inter', sans-serif; font-weight: 500;
        }
        .lp-eyebrow::before {
          content: ""; display: inline-block; width: 32px; height: 1px;
          background: hsl(var(--gold)); vertical-align: middle; margin-right: 12px;
        }
        .lp-h2 {
          font-family: 'Montserrat', sans-serif; font-weight: 300;
          font-size: clamp(34px, 4.5vw, 56px); line-height: 1.05; color: hsl(var(--background));
          letter-spacing: -0.01em;
        }
        .lp-btn-primary {
          display: inline-flex; align-items: center; gap: 10px;
          background: hsl(var(--gold)); color: hsl(var(--navy));
          padding: 16px 32px; font-family: 'Inter', sans-serif; font-weight: 500;
          font-size: 14px; letter-spacing: .04em; text-transform: uppercase;
          border-radius: 2px; transition: all .3s ease; border: 1px solid hsl(var(--gold));
        }
        .lp-btn-primary:hover { background: hsl(43 96% 70%); transform: translateY(-1px); }
        .lp-btn-ghost {
          display: inline-flex; align-items: center; gap: 10px;
          background: transparent; color: hsl(var(--background));
          padding: 16px 32px; font-family: 'Inter', sans-serif; font-weight: 500;
          font-size: 14px; letter-spacing: .04em; text-transform: uppercase;
          border-radius: 2px; border: 1px solid hsla(43,96%,56%,.38);
          transition: all .3s ease;
        }
        .lp-btn-ghost:hover { background: hsla(43,96%,56%,.08); border-color: hsl(var(--gold)); }
        .lp-pill {
          display: inline-block; padding: 8px 18px; border-radius: 40px;
          border: 1px solid hsla(43,96%,56%,.38); background: hsla(43,96%,56%,.06);
          color: hsl(var(--background)); font-family: 'Inter', sans-serif;
          font-size: 12px; font-weight: 400; letter-spacing: .02em;
        }
        .lp-divider-gold { height: 1px; background: hsla(43,96%,56%,.18); }
        .lp-stat-value { font-family: 'Montserrat', sans-serif; font-weight: 300; color: hsl(var(--gold)); }
        .lp-card-num { font-family: 'Inter', sans-serif; font-size: 11px; letter-spacing: .2em; color: hsl(var(--gold)); }
        .lp-card-title { font-family: 'Montserrat', sans-serif; font-weight: 500; font-size: 22px; color: hsl(var(--background)); margin-top: 12px; }
        .lp-card-desc { font-family: 'Inter', sans-serif; font-size: 13px; line-height: 1.65; color: hsla(40,20%,98%,.6); margin-top: 10px; }
        .lp-col-hover { transition: border-color .3s ease; border-bottom: 3px solid transparent; }
        .lp-col-hover:hover { border-bottom-color: hsl(var(--gold)); }
        .lp-watermark {
          position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
          font-family: 'Montserrat', sans-serif; font-weight: 700;
          font-size: clamp(120px, 22vw, 280px); color: hsl(var(--gold));
          opacity: .035; pointer-events: none; letter-spacing: .05em; user-select: none;
        }
      `}</style>

      <div style={{ background: "hsl(var(--navy))", color: "hsl(var(--background))", minHeight: "100vh" }}>
        {/* NAV */}
        <nav
          style={{
            position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
            padding: "20px 40px", display: "flex", justifyContent: "space-between", alignItems: "center",
            background: "linear-gradient(180deg, hsla(220,20%,8%,.95) 0%, transparent 100%)",
          }}
        >
          <a href="/" style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 700, color: "hsl(var(--gold))", textTransform: "uppercase", letterSpacing: ".12em", fontSize: 14 }}>
            Top Class Imóveis
          </a>
          <span style={{ fontFamily: "Inter, sans-serif", fontSize: 11, color: "hsla(40,20%,98%,.55)", letterSpacing: ".05em" }}>
            Paulo Miranda · CRECI-RJ 83590
          </span>
        </nav>

        {/* HERO */}
        <section className="lp-hero-bg" style={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: "120px 40px 80px", position: "relative" }}>
          <div style={{ maxWidth: 1280, margin: "0 auto", width: "100%" }}>
            {/* Título e informações removidos para manter a capa limpa */}
            <Reveal>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
                <a href={waMain} target="_blank" rel="noopener noreferrer" className="lp-btn-primary">Falar com Paulo Miranda</a>
                <a href="#diferenciais" className="lp-btn-ghost">Conhecer o imóvel</a>
              </div>
            </Reveal>
          </div>
          <div style={{ position: "absolute", bottom: 32, left: "50%", transform: "translateX(-50%)", display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
            <div className="lp-scroll-line" />
            <span style={{ fontSize: 10, letterSpacing: ".22em", color: "hsla(40,20%,98%,.55)", textTransform: "uppercase" }}>Explorar</span>
          </div>
        </section>

        {/* BARRA DE PREÇO */}
        <section style={{ background: "hsl(220 20% 12%)", borderTop: "1px solid hsla(43,96%,56%,.18)", borderBottom: "1px solid hsla(43,96%,56%,.18)", padding: "48px 40px" }}>
          <div style={{ maxWidth: 1280, margin: "0 auto", display: "flex", flexWrap: "wrap", gap: 48, justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: ".15em", color: "hsla(40,20%,98%,.55)", marginBottom: 8 }}>Valor de venda</div>
              <div className="lp-stat-value" style={{ fontSize: "clamp(38px, 5vw, 56px)", lineHeight: 1 }}>R$ 1.600.000</div>
              <div style={{ fontSize: 13, color: "hsla(40,20%,98%,.55)", marginTop: 10 }}>Cond. R$ 1.859 · IPTU R$ 2.640/ano</div>
            </div>
            <div style={{ display: "flex", gap: 40, flexWrap: "wrap" }}>
              {[
                ["36 m²", "Área privativa"],
                ["1", "Vaga escritura"],
                ["24h", "Recepção e seg."],
                ["3 min", "À pé · praia"],
              ].map(([v, l]) => (
                <div key={l}>
                  <div className="lp-stat-value" style={{ fontSize: 28, lineHeight: 1 }}>{v}</div>
                  <div style={{ fontSize: 11, color: "hsla(40,20%,98%,.55)", textTransform: "uppercase", letterSpacing: ".12em", marginTop: 6 }}>{l}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* DIFERENCIAIS */}
        <section id="diferenciais" className="lp-section" style={{ background: "hsl(220 20% 11%)" }}>
          <div style={{ maxWidth: 1280, margin: "0 auto" }}>
            <Reveal><div className="lp-eyebrow" style={{ marginBottom: 20 }}>Por que este imóvel</div></Reveal>
            <Reveal>
              <h2 className="lp-h2" style={{ marginBottom: 24 }}>
                Tudo que torna<br />este apart hotel <em className="lp-gold-italic">único.</em>
              </h2>
            </Reveal>
            <Reveal>
              <p style={{ fontFamily: "Inter, sans-serif", color: "hsla(40,20%,98%,.6)", maxWidth: 640, fontSize: 15, lineHeight: 1.7, marginBottom: 64 }}>
                No Leblon, a localização vale mais do que os metros quadrados. Aqui, cada detalhe foi pensado para entregar exclusividade real.
              </p>
            </Reveal>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", border: "1px solid hsla(43,96%,56%,.18)" }}>
              {[
                ["01", "Praia em 3 minutos", "A Praia do Leblon — uma das mais sofisticadas do mundo — a poucos passos da porta. Acesso à orla sem precisar de carro."],
                ["02", "Rua Dias Ferreira", "O polo gastronômico mais valorizado do Rio de Janeiro. Os melhores restaurantes e bares do Brasil literalmente na porta do imóvel."],
                ["03", "Vaga na escritura", "Raridade em apart hotels compactos do Leblon. A vaga é patrimonial — agrega valor à revenda e à renda por temporada."],
                ["04", "Infraestrutura de hotel", "Recepção 24h, segurança, serviço de arrumação e lazer incluso. Tudo que um apartamento residencial não oferece."],
                ["05", "Mobilidade total", "Próximo ao Metrô General Osório, ciclovias e principais vias da Zona Sul. Tudo a pé ou em minutos."],
                ["06", "Leblon valoriza todo ano", "O m² do Leblon é o mais alto do Brasil. Demanda de short stay entre as mais altas — Carnaval, verão, eventos internacionais."],
              ].map(([n, t, d]) => (
                <Reveal key={n}>
                  <div style={{ padding: 40, borderRight: "1px solid hsla(43,96%,56%,.18)", borderBottom: "1px solid hsla(43,96%,56%,.18)", height: "100%" }}>
                    <div className="lp-card-num">{n}</div>
                    <div className="lp-card-title">{t}</div>
                    <div className="lp-card-desc">{d}</div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        {/* MORAR / INVESTIR */}
        <section className="lp-section" style={{ background: "hsl(var(--navy))" }}>
          <div style={{ maxWidth: 1280, margin: "0 auto" }}>
            <Reveal><div className="lp-eyebrow" style={{ marginBottom: 20 }}>Para quem é este imóvel</div></Reveal>
            <Reveal>
              <h2 className="lp-h2" style={{ marginBottom: 64 }}>
                Duas razões para <em className="lp-gold-italic">comprar.</em><br />Um único endereço.
              </h2>
            </Reveal>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 1, background: "hsla(43,96%,56%,.18)" }}>
              <Reveal>
                <div className="lp-col-hover" style={{ background: "hsl(var(--navy))", padding: 56 }}>
                  <div style={{ fontSize: 11, color: "hsl(var(--gold))", letterSpacing: ".15em", textTransform: "uppercase", marginBottom: 24 }}>— Para morar</div>
                  <h3 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 300, fontSize: 32, lineHeight: 1.15, marginBottom: 20, color: "hsl(var(--background))" }}>
                    Qualidade de vida<br /><em className="lp-gold-italic">com praticidade de hotel.</em>
                  </h3>
                  <p style={{ fontFamily: "Inter, sans-serif", fontSize: 14, color: "hsla(40,20%,98%,.65)", lineHeight: 1.7, marginBottom: 28 }}>
                    Viver no Leblon com serviços de hotel — arrumação, recepção, segurança e lazer — e ainda ter a sua vaga garantida. O melhor dos dois mundos em um endereço icônico.
                  </p>
                  <ul style={{ listStyle: "none", padding: 0, margin: "0 0 32px" }}>
                    {["Recepção e segurança 24 horas", "Serviço de arrumação incluso", "Praia, metrô e comércio premium a pé", "Sem burocracia de condomínio residencial", "Pronto para entrar e morar"].map((i) => (
                      <li key={i} style={{ padding: "14px 0", borderBottom: "1px solid hsla(43,96%,56%,.18)", fontSize: 13, color: "hsla(40,20%,98%,.8)", fontFamily: "Inter, sans-serif" }}>{i}</li>
                    ))}
                  </ul>
                  <ScheduleVisitDialog propertyName="Apart Hotel Dias Ferreira - Leblon" neighborhood="Leblon">
                    <button type="button" className="lp-btn-primary">Agendar visita</button>
                  </ScheduleVisitDialog>
                </div>
              </Reveal>
              <Reveal>
                <div className="lp-col-hover" style={{ background: "hsl(220 20% 18%)", padding: 56 }}>
                  <div style={{ fontSize: 11, color: "hsl(var(--gold))", letterSpacing: ".15em", textTransform: "uppercase", marginBottom: 24 }}>— Para investir</div>
                  <h3 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 300, fontSize: 32, lineHeight: 1.15, marginBottom: 20, color: "hsl(var(--background))" }}>
                    Seu dinheiro<br /><em className="lp-gold-italic">trabalhando no Leblon.</em>
                  </h3>
                  <p style={{ fontFamily: "Inter, sans-serif", fontSize: 14, color: "hsla(40,20%,98%,.65)", lineHeight: 1.7, marginBottom: 28 }}>
                    O Leblon tem a maior demanda de short stay da Zona Sul. Verão, Carnaval, eventos internacionais — este apart hotel gera renda o ano inteiro, inclusive quando você não está no Rio.
                  </p>
                  <ul style={{ listStyle: "none", padding: 0, margin: "0 0 32px" }}>
                    {["Alta ocupação via Airbnb e Booking", "Vaga aumenta atratividade do aluguel", "Valorização histórica do m² no Leblon", "Gestão à distância via plataformas digitais", "Infraestrutura de hotel = hóspede satisfeito"].map((i) => (
                      <li key={i} style={{ padding: "14px 0", borderBottom: "1px solid hsla(43,96%,56%,.18)", fontSize: 13, color: "hsla(40,20%,98%,.8)", fontFamily: "Inter, sans-serif" }}>{i}</li>
                    ))}
                  </ul>
                  <a href={waInvestir} target="_blank" rel="noopener noreferrer" className="lp-btn-primary">Receber simulação de ROI</a>
                </div>
              </Reveal>
            </div>
          </div>
        </section>

        {/* LOCALIZAÇÃO */}
        <section className="lp-section" style={{ background: "hsl(220 20% 11%)" }}>
          <div style={{ maxWidth: 1280, margin: "0 auto" }}>
            <Reveal><div className="lp-eyebrow" style={{ marginBottom: 20 }}>Localização</div></Reveal>
            <Reveal>
              <h2 className="lp-h2" style={{ marginBottom: 64 }}>
                Rua Dias Ferreira.<br /><em className="lp-gold-italic">O endereço que dispensa apresentação.</em>
              </h2>
            </Reveal>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 64 }}>
              <Reveal>
                <div>
                  {[
                    ["3'", "Praia do Leblon", "A pé · acesso à orla completa"],
                    ["5'", "Metrô General Osório", "A pé · linha 1 direto ao Centro"],
                    ["0'", "Polo gastronômico", "Rua Dias Ferreira — na porta"],
                    ["8'", "Lagoa Rodrigo de Freitas", "A pé · corrida e lazer"],
                    ["5'", "Shopping Leblon", "A pé · acesso rápido"],
                  ].map(([t, n, d], i) => (
                    <div key={n} style={{ display: "flex", gap: 24, padding: "24px 0", borderTop: i === 0 ? "1px solid hsla(43,96%,56%,.18)" : "none", borderBottom: "1px solid hsla(43,96%,56%,.18)" }}>
                      <div style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 300, fontSize: 36, color: "hsl(var(--gold))", minWidth: 60, lineHeight: 1 }}>{t}</div>
                      <div>
                        <div style={{ fontFamily: "Inter, sans-serif", fontSize: 15, color: "hsl(var(--background))", fontWeight: 500 }}>{n}</div>
                        <div style={{ fontFamily: "Inter, sans-serif", fontSize: 12, color: "hsla(40,20%,98%,.55)", marginTop: 4 }}>{d}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </Reveal>
              <Reveal>
                <div>
                  <blockquote style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 300, fontStyle: "italic", fontSize: 26, lineHeight: 1.35, color: "hsl(var(--gold))", margin: "0 0 32px", borderLeft: "1px solid hsla(43,96%,56%,.38)", paddingLeft: 24 }}>
                    "O Leblon não é apenas um bairro. É o único endereço do Rio que vende a si mesmo."
                  </blockquote>
                  <p style={{ fontFamily: "Inter, sans-serif", fontSize: 14, lineHeight: 1.75, color: "hsla(40,20%,98%,.7)", marginBottom: 24 }}>
                    A Rua Dias Ferreira concentra os melhores restaurantes, bares e experiências gastronômicas do Rio — e este apart hotel fica exatamente aqui. Uma localização que justifica cada centavo do investimento e que nenhuma reforma consegue replicar.
                  </p>
                  <div style={{ width: 48, height: 1, background: "hsla(43,96%,56%,.5)", margin: "24px 0" }} />
                  <p style={{ fontFamily: "Inter, sans-serif", fontSize: 14, lineHeight: 1.75, color: "hsla(40,20%,98%,.7)" }}>
                    Apartamentos com vaga neste corredor raramente ficam disponíveis por mais de 30 dias no mercado.
                  </p>
                </div>
              </Reveal>
            </div>
          </div>
        </section>

        {/* FICHA TÉCNICA */}
        <section className="lp-section" style={{ background: "hsl(220 18% 17%)" }}>
          <div style={{ maxWidth: 1280, margin: "0 auto" }}>
            <Reveal><div className="lp-eyebrow" style={{ marginBottom: 20 }}>Ficha técnica</div></Reveal>
            <Reveal><h2 className="lp-h2" style={{ marginBottom: 56 }}>Os números do imóvel.</h2></Reveal>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: 1, background: "hsla(0,0%,100%,.08)" }}>
              {[
                ["Área privativa", "36", "m²"],
                ["Dormitórios", "1", "quarto"],
                ["Vagas", "1", "escritura"],
                ["Valor", "R$ 1,6", "milhão"],
                ["Condomínio", "R$ 1.859", "/mês"],
                ["IPTU", "R$ 2.640", "/ano"],
                ["Tipo", "Apart", "Hotel"],
                ["Bairro", "Leblon", "Zona Sul RJ"],
              ].map(([l, v, u]) => (
                <div key={l} style={{ background: "hsl(220 18% 17%)", padding: "32px 24px" }}>
                  <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: ".15em", color: "hsla(40,20%,98%,.55)", marginBottom: 12 }}>{l}</div>
                  <div style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 300, fontSize: 28, color: "hsl(var(--background))", lineHeight: 1 }}>{v}</div>
                  <div style={{ fontSize: 13, color: "hsl(var(--gold))", marginTop: 8 }}>{u}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA FINAL */}
        <section className="lp-section" style={{ background: "hsl(220 20% 12%)", position: "relative", overflow: "hidden", textAlign: "center" }}>
          <div className="lp-watermark">LEBLON</div>
          <div style={{ position: "relative", zIndex: 1, maxWidth: 720, margin: "0 auto" }}>
            <Reveal><div className="lp-eyebrow" style={{ marginBottom: 20, display: "inline-block" }}>Próximo passo</div></Reveal>
            <Reveal>
              <h2 className="lp-h2" style={{ marginBottom: 24 }}>
                Pronto para conhecer<br /><em className="lp-gold-italic">o imóvel?</em>
              </h2>
            </Reveal>
            <Reveal>
              <p style={{ fontFamily: "Inter, sans-serif", fontSize: 15, color: "hsla(40,20%,98%,.65)", lineHeight: 1.7, marginBottom: 40 }}>
                Fale diretamente com Paulo Miranda — especialista em imóveis de alto padrão na Zona Sul há mais de 30 anos. Atendimento personalizado, sem intermediários.
              </p>
            </Reveal>
            <Reveal>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 16, justifyContent: "center" }}>
                <a href={waMain} target="_blank" rel="noopener noreferrer" className="lp-btn-primary">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  Falar no WhatsApp agora
                </a>
                <a href="tel:+5521973548387" className="lp-btn-ghost">(21) 97354-8387</a>
              </div>
            </Reveal>
          </div>
        </section>

        {/* FOOTER */}
        <footer style={{ background: "hsl(var(--navy))", borderTop: "1px solid hsla(43,96%,56%,.18)", padding: "48px 40px" }}>
          <div style={{ maxWidth: 1280, margin: "0 auto", display: "flex", flexWrap: "wrap", gap: 32, justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 700, color: "hsl(var(--gold))", fontSize: 18, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 12 }}>
                Top Class Imóveis Premium
              </div>
              <div style={{ fontFamily: "Inter, sans-serif", fontSize: 13, color: "hsla(40,20%,98%,.65)", marginBottom: 6 }}>
                Paulo Miranda · CRECI-RJ 83590 · (21) 97354-8387
              </div>
              <div style={{ fontFamily: "Inter, sans-serif", fontSize: 12, color: "hsla(40,20%,98%,.45)" }}>
                @paulomirandaimoveis · Zona Sul, Rio de Janeiro
              </div>
            </div>
            <div style={{ fontFamily: "Inter, sans-serif", fontSize: 11, color: "hsla(40,20%,98%,.4)", maxWidth: 320, lineHeight: 1.6 }}>
              As informações são de caráter informativo e podem ser alteradas. Imagens meramente ilustrativas.
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ApartHotelLeblon;
